import React, { useEffect } from "react";
import DonutChartProfile from "../Layouts/Graphs/DonutChartProfile";
import _ from "lodash";
import { Dropdown } from "react-bootstrap";
import DatePicker from "react-datepicker";
import ShimmerScreen from "../Layouts/ShimmerScreen";
import ShimmerNotification from "../Layouts/ShimmerNotification";
import moment from "moment";
import ShimmerForProfileTabs from "../Layouts/ShimmerForProfileTabs";
import NotFoundImage from "../NewDesign/NotFound/NotFoundImage";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

const EventDetailSection = ({
  isLoading,
  isEvent,
  eventsData,
  registered,
  attended,
  searchText,
  setSearchText,
  onSearchClicked,
  sections,
  selectedMonth,
  setSelectedMonth,
  isSessionNameAsc,
  isEventNameAsc,
  isDateAsc,
  setDateOrder,
  setEventNameOrder,
  setSessionNameOrder,
  isStatusAsc,
  setStatusOrder,
  isOther,
}) => {
  const { t } = useTranslation();
  useEffect(() => {
    // if (searchText?.length > 2) {
    //   onSearchClicked();
    // } else
    if (searchText === "") {
      onSearchClicked();
    }
  }, [searchText]);

  let navigate = useNavigate();
  const search = window.location.search;
  const params = new URLSearchParams(search);

  const tab = params.get("tab");

  const navigateToDetail = (item) => {
    if (tab === "4") {
      if (item.source === "broker") {
        let paramsReq = {
          event_id: item.event_id,
          event_code: "",
          source: "broker",
        };
        let jsonString = JSON.stringify(paramsReq);
        let encodedUrl = btoa(jsonString);
        navigate(`/group-workshop-detail?c=${encodedUrl}`);
      } else {
        let paramsReq = {
          event_id: item.event_id,
          event_code: item.event_code,
          source: item.source,
        };

        let jsonString = JSON.stringify(paramsReq);
        let encodedUrl = btoa(jsonString);
        navigate(`/group-workshop-detail?c=${encodedUrl}`);
      }
    } else if (tab === "5") {
      if (item.source === "broker") {
        let paramsReq = {
          event_id: item.event_id,
          event_code: "",
          source: "broker",
          fromCert: true,
        };
        let jsonString = JSON.stringify(paramsReq);
        let encodedUrl = btoa(jsonString);
        navigate(`/group-workshop-detail?c=${encodedUrl}`);
      } else {
        let paramsReq = {
          event_id: item.event_id,
          event_code: item.event_code,
          source: item.source,
          fromCert: true,
        };

        let jsonString = JSON.stringify(paramsReq);
        let encodedUrl = btoa(jsonString);
        navigate(`/group-workshop-detail?c=${encodedUrl}`);
      }
    }
  };

  return (
    <div className="profile-info-wrapper">
      <div className="profile-info-title d-flex justify-content-between gap-3 align-items-center flex-wrap">
        <div className="title-box">{isEvent ? "Events" : "Certifications"}</div>
        <div className="from-notes-wrapper">
          <div className="search-info">
            <div className="confirm-row m-0">
              <input
                type="search"
                id="search"
                name="search"
                className="form-control"
                placeholder={`${
                  isEvent ? t("events/sessions") : t("certifications/sessions")
                }`}
                value={searchText}
                onChange={(e) => setSearchText(e.target.value)}
                disabled={isLoading}
              />
              <button className="confirm-btn" onClick={() => onSearchClicked()}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                >
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M9.16667 1.66669C5.02454 1.66669 1.66667 5.02455 1.66667 9.16669C1.66667 13.3088 5.02454 16.6667 9.16667 16.6667C10.9375 16.6667 12.565 16.053 13.8481 15.0266L16.9107 18.0893C17.2362 18.4147 17.7638 18.4147 18.0893 18.0893C18.4147 17.7638 18.4147 17.2362 18.0893 16.9108L15.0266 13.8481C16.0529 12.565 16.6667 10.9375 16.6667 9.16669C16.6667 5.02455 13.3088 1.66669 9.16667 1.66669ZM3.33334 9.16669C3.33334 5.94503 5.94501 3.33335 9.16667 3.33335C12.3883 3.33335 15 5.94503 15 9.16669C15 12.3883 12.3883 15 9.16667 15C5.94501 15 3.33334 12.3883 3.33334 9.16669Z"
                    fill="black"
                  ></path>
                </svg>
                {t("Search")}
              </button>
            </div>
            {/* <div className="input-text position-relative d-flex align-items-center gap-2">
              <label htmlFor="search" className="input__label mb-0">
                Search
              </label>
              <input
                type="search"
                id="search"
                name="search"
                className="input_field mr-2"
                placeholder={`${
                  isEvent ? "events/sessions" : "certifications/sessions"
                }`}
                value={searchText}
                onChange={(e) => setSearchText(e.target.value)}
                disabled={isLoading}
              />
            </div> */}
          </div>
          <div className="datemonth-wrapper">
            <svg
              className="calshwo"
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="#ffffff"
            >
              <path d="M9 1V3H15V1H17V3H21C21.5523 3 22 3.44772 22 4V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3H7V1H9ZM20 11H4V19H20V11ZM7 5H4V9H20V5H17V7H15V5H9V7H7V5Z"></path>
            </svg>
            <DatePicker
              id="datePick"
              selected={selectedMonth}
              showYearPicker
              dateFormat="yyyy"
              // maxDate={new Date()}
              onChange={(date) => setSelectedMonth(date)}
              disabled={isLoading}
            />
            <svg
              className="cursor-pointer dropcal"
              onClick={() => {
                document.getElementById("datePick").click();
              }}
              width="40"
              height="40"
              viewBox="0 0 40 40"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g opacity="0.8" filter="url(#filter0_f_2341_22533)">
                <ellipse cx="20" cy="20.001" rx="8" ry="8" fill="#444444" />
              </g>
              <circle
                cx="18"
                cy="18.0005"
                r="12"
                transform="rotate(-180 18 18.0005)"
                fill="#FEF6D5"
              />
              <path
                d="M22.6666 16.0013L17.9999 20.668L13.3333 16.0013"
                stroke="#444444"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <defs>
                <filter
                  id="filter0_f_2341_22533"
                  x="0"
                  y="0.000976562"
                  width="40"
                  height="40"
                  filterUnits="userSpaceOnUse"
                  color-interpolation-filters="sRGB"
                >
                  <feFlood flood-opacity="0" result="BackgroundImageFix" />
                  <feBlend
                    mode="normal"
                    in="SourceGraphic"
                    in2="BackgroundImageFix"
                    result="shape"
                  />
                  <feGaussianBlur
                    stdDeviation="6"
                    result="effect1_foregroundBlur_2341_22533"
                  />
                </filter>
              </defs>
            </svg>
          </div>
        </div>
      </div>
      <div className="graph-prolie-info">
        {false && (
          <div className="graph-shpw">
            <DonutChartProfile
              sections={sections}
              name={isEvent ? "Events" : "Certifications"}
              isLoading={isLoading}
            />
          </div>
        )}
        <div className="graph-info-boxes">
          {isLoading ? (
            [0].map((item) => {
              return (
                <div className="graph-info-wrap">
                  <ShimmerScreen height={"25px"} width={"100%"} case={"rect"} />
                </div>
              );
            })
          ) : (
            <>
              {false && (
                <div className="graph-info-wrap completed">
                  <div class="icon">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width={32}
                      height={32}
                      viewBox="0 0 24 24"
                      fill="currentColor"
                    >
                      <path d="M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20ZM11.0026 16L6.75999 11.7574L8.17421 10.3431L11.0026 13.1716L16.6595 7.51472L18.0737 8.92893L11.0026 16Z"></path>
                    </svg>
                  </div>{" "}
                  {attended} Attended
                </div>
              )}
              <div className="graph-info-wrap inprogress">
                <div class="icon">
                  <svg
                    width={32}
                    height={32}
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    fill="currentColor"
                  >
                    <path d="M12 2C17.52 2 22 6.48 22 12C22 17.52 17.52 22 12 22C6.48 22 2 17.52 2 12C2 6.48 6.48 2 12 2ZM12 20C16.42 20 20 16.42 20 12C20 7.58 16.42 4 12 4C7.58 4 4 7.58 4 12C4 16.42 7.58 20 12 20ZM15.5355 7.05025L16.9497 8.46447L12 13.4142L10.5858 12L15.5355 7.05025Z"></path>
                  </svg>
                </div>{" "}
                {registered} {t("Registered")}
              </div>
            </>
          )}
        </div>
      </div>
      <div className="course-info-table">
        <table class="table mb-0 office_list table-striped video-list">
          <thead>
            <tr>
              <th className="srno">Sl. No</th>
              <th
                className={`name-tile cursor-pointer is-sort ${
                  isEventNameAsc ? "selected-sort" : ""
                }`}
                onClick={() => setEventNameOrder()}
              >
                {isEvent ? t("Event Name") : t("Certification Name")}
              </th>
              <th
                className={`name-tile cursor-pointer is-sort ${
                  isSessionNameAsc ? "selected-sort" : ""
                }`}
                onClick={() => setSessionNameOrder()}
              >
                {t("Session Name")}
              </th>
              <th
                className={`status-tile `}
                // onClick={() => setStatusOrder()}
              >
                {t("Status")}
              </th>
              <th
                className={`status-tile cursor-pointer is-sort ${
                  isDateAsc ? "selected-sort" : ""
                }`}
                onClick={() => setDateOrder()}
              >
                {t("Date")}
              </th>
            </tr>
          </thead>
          <tbody>
            {isLoading ? (
              <tr className="not-found">
                <td colSpan={5}>
                  {[1, 2, 3].map((m) => {
                    return (
                      <ShimmerForProfileTabs key={`notify-${m}-shimmer`} />
                    );
                  })}
                </td>
              </tr>
            ) : !_.isEmpty(eventsData) ? (
              eventsData?.map((item, index) => {
                return (
                  <tr>
                    <td>{index + 1}</td>
                    <td
                      className={`${isOther === "0" ? "cursor-pointer" : ""} `}
                      title={item?.event_name}
                      onClick={() =>
                        isOther === "0" ? navigateToDetail(item) : ""
                      }
                    >
                      {isOther === "0" ? (
                        <u
                          className="p_wrap "
                          dangerouslySetInnerHTML={{ __html: item?.event_name }}
                        ></u>
                      ) : (
                        item?.event_name
                      )}
                    </td>
                    <td>{item?.session_name}</td>
                    <td>{item?.status}</td>
                    <td>
                      {item?.date
                        ? moment(item?.date).format("DD MMM, YYYY")
                        : "-"}
                    </td>
                  </tr>
                );
              })
            ) : (
              <tr className="not-found">
                <td colSpan={5}>
                  <NotFoundImage />
                  {/* <img src="/images/finwell-img/NoSearchResults.svg" alt="Not Found" /> */}
                  <p>{t("No Data Found.")}</p>
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default EventDetailSection;
